import {
    LockOpen,
    Business,
    Cached,
    Description,
    People,
    EmojiPeople,
    CreditCard,
    FolderOpen,
    House,
    Apartment,
    FlightLand,
    AccountBalance,
    Work,
    AssignmentLate,
    Assignment,
    Category,
} from './lawyerTypeIcons'

const SMALL = 'smallMandate'
const COMM = 'commercial'
const LEGAL_AID = 'juridicalHelp'
const MP = 'normal'

export const lawyerTypesON = [
    {
        name: 'on-admin',
        label: 'Administratif',
        icon: Description,
        children: [
            {
                name: 'on-divisional',
                label: 'Cour divisionnaire',
            },
            {
                name: 'on-social-help',
                label: 'Aide sociale / chômage',
            },
            {
                name: 'on-aivo',
                label: 'AIVO',
            },

            {
                name: 'on-pensions',
                label: 'Rentes / pensions',
            },
        ],
    },
    {
        name: 'on-business',
        label: 'Affaires',
        icon: Business,

        children: [
            {
                name: 'on-corp-start',
                label: 'Corporatif (démarrage)',
            },
            {
                name: 'on-corp-franchise',
                label: 'Corporatif (franchisage)',
            },
            {
                name: 'on-corp-ma',
                label: 'Corporatif (fusion/achat/vente/transfert)',
            },
            {
                name: 'on-corp-npo',
                label: 'Corporatif (OBNL)',
            },
            {
                name: 'on-corp-reorg',
                label: 'Corporatif (réorganisation)',
            },
            {
                name: 'on-business-litige',
                label: 'Litige',
            },
            {
                name: 'on-litige-action',
                label: 'Litige (recouvrement de créances)',
            },
            {
                name: 'on-litige-competition',
                label: 'Litige (Clauses de non-concurrence et concurrence déloyale)',
            },
            {
                name: 'on-litige-shareholders',
                label: 'Litige (entre actionnaires)',
            },
            {
                name: 'on-litige-post-transac',
                label: 'Litige (post-transaction)',
            },

            {
                name: 'on-commercial',
                label: 'Commercial (contractuel)',
            },
            {
                name: 'on-arbitrage',
                label: 'Arbitrage et médiation commerciale',
            },
            {
                name: 'on-ip',
                label: 'Propriété intellectuelle',
            },
            {
                name: 'on-corp-minutes',
                label: 'Livres des minutes',
            },
        ],
    },
    {
        name: 'on-criminal',
        label: 'Criminel et infraction réglementaire',
        jh: true,
        icon: LockOpen,
        certRequired: true,
        children: [
            {
                name: 'on-criminal-crim',
                label: 'Criminel',
                disabled: true,
            },
            {
                name: 'on-crim-firearm',
                label: 'Criminel (arme à feu)',
            },
            {
                name: 'on-crim-person',
                label: 'Criminel (menaces)',
            },
            {
                name: 'on-crim-prop',
                label: 'Criminel (contre les droits de propriété)',
            },
            {
                name: 'on-crim-fraud',
                label: 'Criminel (fraude)',
            },
            {
                name: 'on-crim-youth',
                label: 'Criminel (jeune contrevenant)',
            },
            {
                name: 'on-crim-transport',
                label: 'Criminel (moyen de transport)',
            },
            {
                name: 'on-crim-waiver',
                label: 'Criminel (pardon/waiver)',
            },
            {
                name: 'on-crim-sex',
                label: 'Criminel (sexuel)',
            },
            {
                name: 'on-crim-stup',
                label: 'Criminel (stupéfiant)',
            },
            {
                name: 'on-criminal-penal',
                label: 'Pénal',
                disabled: true,
            },
            {
                name: 'on-penal-hunting',
                label: 'Pénal (chasse)',
            },
            {
                name: 'on-penal-enterprise',
                label: 'Pénal (entreprise)',
            },
            {
                name: 'on-penal-environment',
                label: 'Pénal (environnement)',
            },
            {
                name: 'on-penal-road',
                label: 'Pénal (route)',
            },
            {
                name: 'on-penal-other',
                label: 'Infraction pénal (autre)',
            },
            {
                name: 'on-theft-5000-less',
                label: 'Vol',
                paralegal: true,
            },
            {
                name: 'on-crim-harassment',
                label: 'Harcèlement criminel',
            },
            {
                name: 'on-crim-assault',
                label: 'Voies de fait',
                paralegal: true,
            },
        ],
    },
    {
        name: 'on-rights',
        label: 'Droits et libertés',
        jh: true,
        icon: EmojiPeople,

        children: [
            {
                name: 'on-rights-liberty',
                label: 'Droits et libertés',
                disabled: true,
            },
            {
                name: 'on-rights-native',
                label: 'Autochtone',

                certRequired: true,
            },
            {
                name: 'on-rights-constitution',
                label: 'Constitution et chartes',
            },
            {
                name: 'on-rights-protection',
                label: 'Personnes vulnérables (curatelle, tutelle, conseil au majeur)',

                certRequired: true,
            },
            {
                name: 'on-rights-care',
                label: 'Soin et garde en établissement',

                certRequired: true,
            },
            {
                name: 'on-rights-tribunal',
                label: `Tribunal des droits de la personne de l’Ontario`,
                paralegal: true,
            },
        ],
    },
    {
        name: 'on-bankruptcy',
        label: 'Faillite et insolvabilité',
        icon: CreditCard,

        children: [
            {
                name: 'on-bankruptcy-enterprise',
                label: 'Entreprise',
                defaultBlockType: COMM,
            },
            {
                name: 'on-bankruptcy-person',
                label: 'Particulier',
                defaultBlockType: MP,
            },
        ],
    },
    {
        name: 'on-family',
        label: 'Famille et protection de la jeunesse',
        jh: true,
        icon: People,
        certRequired: true,

        children: [
            {
                name: 'on-family-family',
                label: 'Divorce/Séparation',
                paralegal: true,
            },
            {
                name: 'on-family-youth',
                label: 'Jeunesse',
            },
            {
                name: 'on-family-mediation',
                label: 'Médiation familiale',
            },
            {
                name: 'on-violence',
                label: 'Violence conjugale',
                certRequired: true,
            },
            {
                name: 'on-family-contested',
                label: 'Dossiers non-contestés',
                paralegal: true,
            },
            {
                name: 'on-family-child-spousal-over-150k',
                label: 'Pension alimentaire (revenu de plus de 150 000$)',
            },
            {
                name: 'on-family-child-spousal-under-150k',
                label: 'Pension alimentaire (revenu de 150 000$ et moins)',
                paralegal: true,
            },
            {
                name: 'on-family-custody',
                label: 'Garde pour enfant',
            },
        ],
    },
    {
        name: 'on-fiscal',
        label: 'Fiscalité et taxes',
        icon: FolderOpen,

        children: [
            {
                name: 'on-fiscal-enterprise',
                label: 'Entreprise',
            },
            {
                name: 'on-fiscal-person',
                label: 'Particulier',
            },
        ],
    },
    {
        name: 'on-realestate',
        label: 'Immobilier',
        icon: House,

        children: [
            {
                name: 'on-construction',
                label: 'Construction',
            },
            {
                name: 'on-condo',
                label: 'Copropriété',
            },
            {
                name: 'on-realestate-title',
                label: 'Titre, bornage, servitude, etc',
            },
            {
                name: 'on-realestate-vice',
                label: 'Litige',
            },
            {
                name: 'on-realestate-transaction',
                label: 'Transactions',
            },
        ],
    },
    {
        name: 'on-rental',
        label: 'Logement',
        icon: Apartment,
        jh: true,

        paralegal: true,
        children: [
            {
                name: 'on-rental-landlord',
                label: 'Propriétaire',
                paralegal: true,
            },
            {
                name: 'on-rental-renter',
                label: 'Locataire',
                paralegal: true,
            },
        ],
    },
    {
        name: 'on-immigration',
        label: 'Immigration et citoyenneté',
        icon: FlightLand,
        paralegal: true,
        certRequired: true,
        immigrationConsultant: true,

        children: [
            {
                name: 'on-immigration-sponsorship',
                label: 'Parrainage',
                paralegal: true,
                immigrationConsultant: true,
            },
            {
                name: 'on-immigration-work-permit',
                label: `Permis d'étude et de travail`,
                paralegal: true,
                immigrationConsultant: true,
            },
            {
                name: 'on-immigration-refugee',
                label: 'Réfugié',
                paralegal: true,
                certRequired: true,

                immigrationConsultant: true,
            },
            {
                name: 'on-immigration-permanent',
                label: 'Résidence permanente',
                paralegal: true,
                immigrationConsultant: true,
            },
            {
                name: 'on-immigration-contest',
                label: 'Contestation (contrôle et appel)',
                paralegal: true,
                immigrationConsultant: true,
            },
            {
                name: 'on-immigration-usa',
                label: 'USA',
                immigrationConsultant: true,
            },
            {
                name: 'on-immigration-other',
                label: 'Autre',
                paralegal: true,
                immigrationConsultant: true,
            },
        ],
    },
    {
        name: 'on-municipal',
        label: 'Municipal',
        icon: AccountBalance,
        children: null,
        topLevel: true,
    },
    {
        name: 'on-responsability',
        label: 'Responsabilité civile',
        icon: AssignmentLate,

        children: [
            {
                name: 'on-responsability-general',
                label: 'Générale',
            },
            {
                name: 'on-responsability-slander',
                label: 'Diffamation / atteinte à la réputation',
            },
            {
                name: 'on-responsability-injury',
                label: 'Blessure corporelle',
            },
            {
                name: 'on-responsability-medical',
                label: 'Erreur médicale',
            },
            {
                name: 'on-responsability-pro',
                label: 'Professionnelle et disciplinaire',
            },
            {
                name: 'on-responsability-neighborhood',
                label: 'Trouble de voisinage',
            },
            {
                name: 'on-responsability-sabia',
                label: `Demandes d'indemnités d'accident couvertes par Loi sur les Assurances`,
                paralegal: true,
            },
        ],
    },
    {
        name: 'on-succession',
        label: 'Succession',
        children: null,
        topLevel: true,
        icon: Cached,
        children: [
            {
                name: 'on-estate-admin',
                label: 'Administration de succession',
            },
            {
                name: 'on-estate-litigation',
                label: 'Litige successoral',
            },
            {
                name: 'on-estate-wills',
                label: 'Testaments',
            },
        ],
    },
    {
        name: 'on-work',
        label: 'Travail',
        icon: Work,
        children: [
            {
                name: 'on-work-employee',
                label: 'Harcèlement / pratiques interdites',
            },
            {
                name: 'on-work-employer',
                label: 'Employeur',
            },
            {
                name: 'on-wsib',
                label: 'WSIB',
                paralegal: true,
            },
            {
                name: 'on-work-termination',
                label: 'Congédiement',
            },
        ],
    },
    {
        name: 'on-civil',
        label: 'Civil (général)',
        icon: Assignment,

        children: [
            {
                name: 'on-colAction',
                label: 'Action collective',
            },
            {
                name: 'on-civil-account',
                label: 'Action sur compte',
            },
            {
                name: 'on-civil-prop-insurance',
                label: 'Assurance (biens)',
            },
            {
                name: 'on-civil-health-insurance',
                label: 'Assurance (personne)',
            },
            {
                name: 'on-consumer',
                label: 'Consommation',
            },
            {
                name: 'on-contracts',
                label: 'Contrats, vente et louage',
            },
            {
                name: 'on-civil-banking',
                label: 'Bancaire',
            },
            {
                name: 'on-civil-small-claims',
                label: 'Cour des petites créances',
                paralegal: true,
            },
        ],
    },
]

export const lawyerTypes = [
    {
        name: 'family',
        label: 'Famille et jeunesse',
        jh: true,
        icon: People,

        children: [
            {
                name: 'family-family',
                label: 'Famille (non constestée)',
            },
            {
                name: 'family-contested',
                label: 'Famille (contesté)',
            },
            {
                name: 'family-youth',
                label: 'Jeunesse',
            },
            {
                name: 'family-mediation',
                label: 'Médiation familiale',
            },
        ],
    },
    {
        name: 'business',
        label: 'Affaires',
        icon: Business,

        children: [
            {
                name: 'corp-start',
                label: 'Corporatif (démarrage)',
            },
            {
                name: 'corp-franchise',
                label: 'Corporatif (franchisage)',
            },
            {
                name: 'corp-ma',
                label: 'Corporatif (fusion/achat/vente/transfert)',
            },
            {
                name: 'corp-npo',
                label: 'Corporatif (OBNL)',
            },
            {
                name: 'corp-reorg',
                label: 'Corporatif (réorganisation)',
            },
            {
                name: 'corp-tech',
                label: 'Corporatif (technologie)',
            },
            {
                name: 'business-litige',
                label: 'Litige',
            },
            {
                name: 'litige-action',
                label: 'Litige (action sur compte)',
            },
            {
                name: 'litige-competition',
                label: 'Litige (Clauses de non-concurrence et concurrence déloyale)',
            },
            {
                name: 'litige-shareholders',
                label: 'Litige (entre actionnaires)',
            },
            {
                name: 'litige-post-transac',
                label: 'Litige (post-transaction)',
            },
            {
                name: 'commercial',
                label: 'Commercial (contractuel)',
            },
            {
                name: 'arbitrage',
                label: 'Arbitrage et médiation commerciale',
            },
            {
                name: 'ip',
                label: 'Propriété intellectuelle',
            },
            {
                name: 'corp-minutes',
                label: 'Livres des minutes',
            },
        ],
        leadFormChildren: [
            {
                label: 'Démarrage',
                name: 'corp-start',
            },
            {
                label: 'Commercial',
                name: 'commercial',
            },
            {
                label: 'Achat-Vente',
                name: 'corp-ma',
            },
            {
                label: 'Franchise',
                name: 'corp-franchise',
            },
            {
                label: 'Litige entre actionnaires',
                name: 'litige-shareholders',
            },
            {
                label: 'Immobilier',
                name: 'realestate',
            },
            {
                label: 'Travail',
                name: 'work-employer',
            },
            {
                label: 'Litige (autre)',
                name: 'litige-other',
            },
            {
                label: 'Fiscalité',
                name: 'fiscal-enterprise',
            },
            {
                label: 'Faillite et insolvabilité',
                name: 'bankruptcy-enterprise',
            },
            {
                label: 'Propriété intellectuelle',
                name: 'ip',
            },
            {
                label: 'Autres',
                name: 'business',
            },
        ],
    },
    {
        name: 'criminal',
        label: 'Criminel et pénal',
        jh: true,
        icon: LockOpen,

        children: [
            {
                name: 'criminal-crim',
                label: 'Criminel',
                disabled: true,
            },
            {
                name: 'crim-carceral',
                label: 'Carcéral',
            },
            {
                name: 'crim-police-deontology',
                label: 'Déontologie policière',
            },
            {
                name: 'crim-firearm',
                label: 'Criminel (arme à feu)',
            },
            {
                name: 'crim-person',
                label: 'Criminel (contre la personne et la réputation)',
            },
            {
                name: 'crim-prop',
                label: 'Criminel (contre les droits de propriété)',
            },

            {
                name: 'theft-5000-less',
                label: 'Criminel (vol/fraude - de 5 K)',
            },
            {
                name: 'theft-5000-more',
                label: 'Criminel (vol/fraude + de 5 K)',
            },
            {
                name: 'crim-fraud',
                label: 'Criminel (fraude)',
            },
            {
                name: 'crim-youth',
                label: 'Criminel (jeune contrevenant)',
            },
            {
                name: 'crim-transport',
                label: 'Criminel (moyen de transport)',
            },
            {
                name: 'crim-waiver',
                label: 'Criminel (pardon/waiver)',
            },
            {
                name: 'crim-sex',
                label: 'Criminel (sexuel)',
            },
            {
                name: 'crim-stup',
                label: 'Criminel (stupéfiant)',
            },
            {
                name: 'crim-murder',
                label: 'Criminel (homicide/meurtre)',
            },
            {
                name: 'criminal-penal',
                label: 'Pénal',
                disabled: true,
            },
            {
                name: 'penal-hunting',
                label: 'Pénal (chasse)',
            },
            {
                name: 'penal-enterprise',
                label: 'Pénal (entreprise)',
            },
            {
                name: 'penal-environment',
                label: 'Pénal (environnement)',
            },
            {
                name: 'penal-road',
                label: 'Pénal (infraction de la route)',
            },
            {
                name: 'penal-other',
                label: 'Pénal (autre)',
            },
        ],
    },
    {
        name: 'realestate',
        label: 'Immobilier',
        icon: House,

        children: [
            {
                name: 'construction',
                label: 'Construction',
            },
            {
                name: 'condo',
                label: 'Copropriété',
            },
            {
                name: 'realestate-title',
                label: 'Titre, bornage, servitude, etc',
            },
            {
                name: 'realestate-vice',
                label: 'Vice caché',
            },
            {
                name: 'realestate-transaction',
                label: 'Achat/Vente',
            },
        ],
    },
    {
        name: 'immigration',
        label: 'Immigration et citoyenneté',
        icon: FlightLand,

        immigrationConsultant: true,

        children: [
            {
                name: 'immigration-sponsorship',
                label: 'Parrainage',

                immigrationConsultant: true,
            },
            {
                name: 'immigration-work-permit',
                label: `Permis d'étude et de travail`,

                immigrationConsultant: true,
            },
            {
                name: 'immigration-refugee',
                label: 'Réfugié',

                immigrationConsultant: true,
            },
            {
                name: 'immigration-permanent',
                label: 'Résidence permanente ',

                immigrationConsultant: true,
            },
            {
                name: 'immigration-contest',
                label: 'Contestation (contrôle et appel)',

                immigrationConsultant: true,
            },
            {
                name: 'immigration-agency',
                label: 'Agence internationale de recrutement/placement',

                immigrationConsultant: true,
            },
            {
                name: 'immigration-employer',
                label: 'Employeur',

                immigrationConsultant: true,
            },
            {
                name: 'immigration-other',
                label: 'Autre',

                immigrationConsultant: true,
            },
        ],
    },
    {
        name: 'admin',
        jh: true,
        label: 'Administratif',
        icon: Description,

        children: [
            {
                name: 'admin-social',
                label: 'Aide sociale / chômage',
            },
            {
                name: 'admin-cnesst',
                label: 'CNESST',
            },
            {
                name: 'admin-cptaq',
                label: 'CPTAQ',
            },
            {
                name: 'admin-saaq',
                label: 'SAAQ (administratif)',
            },
            {
                name: 'admin-saaq-accident',
                label: 'SAAQ (accident/blessure)',
            },
            {
                name: 'admin-ivac',
                label: 'IVAC',
            },
            {
                name: 'admin-rentes',
                label: 'Rentes / Pension',
            },
            {
                name: 'admin-scolaire',
                label: 'Scolaire',
            },
            {
                name: 'admin-transport',
                label: 'Transport',
            },
            {
                name: 'admin-autres',
                label: 'Autres',
            },
        ],
    },
    {
        name: 'responsability',
        label: 'Responsabilité civile',
        icon: AssignmentLate,

        children: [
            {
                name: 'responsability-general',
                label: 'Générale',
            },
            {
                name: 'responsability-slander',
                label: 'Diffamation / atteinte à la réputation',
            },
            {
                name: 'responsability-injury',
                label: 'Blessure corporelle',
            },
            {
                name: 'responsability-medical',
                label: 'Erreur médicale',
            },
            {
                name: 'responsability-pro',
                label: 'Professionnelle et disciplinaire',
            },
            {
                name: 'responsability-sexual',
                label: 'Sexuel',
            },
            {
                name: 'responsability-neighborhood',
                label: 'Trouble de voisinage',
            },
        ],
    },
    {
        name: 'work',
        label: 'Travail',
        icon: Work,

        children: [
            {
                name: 'work-employee',
                label: 'Harcèlement / pratiques interdites',
            },
            {
                name: 'work-employer',
                label: 'Employeur',
            },
            {
                name: 'work-termination',
                label: 'Congédiement (salarié)',
            },
            {
                name: 'work-termination-exec',
                label: 'Congédiement (cadre supérieur)',
            },
        ],
    },
    {
        name: 'civil',
        label: 'Civil (général)',
        icon: Assignment,

        children: [
            {
                name: 'colAction',
                label: 'Action collective',
            },
            {
                name: 'civil-account',
                label: 'Action sur compte',
            },
            {
                name: 'civil-prop-insurance',
                label: 'Assurance (biens)',
            },
            {
                name: 'civil-health-insurance',
                label: 'Assurance (personne)',
            },
            {
                name: 'consumer',
                label: 'Consommation',
            },
            {
                name: 'contracts',
                label: 'Contrats, vente et louage',
            },
            {
                name: 'civil-banking',
                label: 'Bancaire',
            },
            {
                name: 'civil-other',
                label: 'Autre',
            },
            {
                name: 'civil-small-claims',
                label: 'Cour des petites créances',
            },
        ],
    },

    {
        name: 'fiscal',
        label: 'Fiscalité et taxes',
        icon: FolderOpen,

        children: [
            {
                name: 'fiscal-enterprise',
                label: 'Entreprise',
            },
            {
                name: 'fiscal-person',
                label: 'Particulier',
            },
        ],
    },

    {
        name: 'rental',
        label: 'Logement',
        icon: Apartment,
        jh: true,

        children: [
            {
                name: 'rental-landlord',
                label: 'Propriétaire',
            },
            {
                name: 'rental-renter',
                label: 'Locataire',
            },
        ],
    },
    {
        name: 'succession',
        label: 'Succession',
        children: null,
        topLevel: true,
        icon: Cached,

        children: [
            {
                name: 'estate-admin',
                label: 'Administration de succession',
            },
            {
                name: 'estate-litigation',
                label: 'Litige successoral',
            },
            {
                name: 'estate-wills',
                label: 'Testaments',
            },
        ],
    },
    {
        name: 'rights',
        label: 'Droits et libertés',
        jh: true,
        icon: EmojiPeople,

        children: [
            {
                name: 'rights-liberty',
                label: 'Droits et libertés',
                disabled: true,
            },
            {
                name: 'rights-native',
                label: 'Autochtone',
            },
            {
                name: 'rights-constitution',
                label: 'Constitution et chartes',
            },
            {
                name: 'rights-protection',
                label: 'Personnes vulnérables (curatelle, tutelle, conseil au majeur)',
            },
            {
                name: 'rights-care',
                label: 'Soin et garde en établissement',
            },
            {
                name: 'rights-nrc-taq',
                label: 'NRC / TAQ',
            },
        ],
    },
    {
        name: 'bankruptcy',
        label: 'Faillite et insolvabilité',
        icon: CreditCard,

        children: [
            {
                name: 'bankruptcy-enterprise',
                label: 'Entreprise',
            },
            {
                name: 'bankruptcy-person',
                label: 'Particulier',
            },
        ],
    },
    {
        name: 'municipal',
        label: 'Municipal',
        icon: AccountBalance,
        children: null,
        topLevel: true,
    },

    {
        name: 'other',
        label: 'Autre/Ne sais pas',
        icon: Category,
        topLevel: true,
        children: null,
    },
]

export const lawyerTypesAB = [
    {
        name: 'ab-admin',
        label: 'Administratif',
        children: [
            {
                name: 'ab-vcap',
                label: 'VCAP',
            },
            {
                name: 'ab-king-bench',
                label: 'Cour du Banc du Roi',
            },

            {
                name: 'ab-pensions',
                label: 'Rentes / pensions',
            },
            {
                name: 'ab-social-help',
                label: 'Aide sociale / chômage',
            },
        ],
    },
    {
        name: 'ab-bankruptcy',
        label: 'Faillite et insolvabilité',
        children: [
            {
                name: 'ab-bankruptcy-enterprise',
                label: 'Entreprise',
            },
            {
                name: 'ab-bankruptcy-person',
                label: 'Particulier',
            },
        ],
    },
    {
        name: 'ab-business',
        label: 'Affaires',
        children: [
            {
                name: 'ab-arbitrage',
                label: 'Arbitrage et médiation commerciale',
            },
            {
                name: 'ab-business-litige',
                label: 'Litige',
            },
            {
                name: 'ab-commercial',
                label: 'Commercial (contractuel)',
            },
            {
                name: 'ab-corp-franchise',
                label: 'Corporatif (franchisage)',
            },
            {
                name: 'ab-corp-ma',
                label: 'Corporatif (fusion/achat/vente/transfert)',
            },
            {
                name: 'ab-corp-minutes',
                label: 'Livres des minutes',
            },
            {
                name: 'ab-corp-npo',
                label: 'Corporatif (OBNL)',
            },
            {
                name: 'ab-corp-reorg',
                label: 'Corporatif (réorganisation)',
            },
            {
                name: 'ab-corp-start',
                label: 'Corporatif (démarrage)',
            },
            {
                name: 'ab-ip',
                label: 'Propriété intellectuelle',
            },
            {
                name: 'ab-litige-action',
                label: 'Litige (recouvrement de créances)',
            },
            {
                name: 'ab-litige-competition',
                label: 'Litige (Clauses de non-concurrence et concurrence déloyale)',
            },

            {
                name: 'ab-litige-post-transac',
                label: 'Litige (post-transaction)',
            },
            {
                name: 'ab-litige-shareholders',
                label: 'Litige (entre actionnaires)',
            },
        ],
    },
    {
        name: 'ab-civil',
        label: 'Civil (général)',
        children: [
            {
                name: 'ab-civil-account',
                label: 'Action sur compte',
            },
            {
                name: 'ab-civil-banking',
                label: 'Bancaire',
            },
            {
                name: 'ab-civil-health-insurance',
                label: 'Assurance (personne)',
            },
            {
                name: 'ab-civil-prop-insurance',
                label: 'Assurance (biens)',
            },
            {
                name: 'ab-civil-small-claims',
                label: 'Cour des petites créances',
            },
            {
                name: 'ab-colAction',
                label: 'Action collective',
            },
            {
                name: 'ab-consumer',
                label: 'Droit Consommateur',
            },
            {
                name: 'ab-contracts',
                label: 'Contrats, vente et louage',
            },
        ],
    },
    {
        name: 'ab-criminal',
        label: 'Criminel et infraction réglementaire',
        certRequired: true,
        children: [
            {
                name: 'ab-crim-assault',
                label: 'Voies de fait',
            },
            {
                name: 'ab-crim-firearm',
                label: 'Criminel (arme à feu)',
            },
            {
                name: 'ab-crim-fraud',
                label: 'Criminel (fraude)',
            },
            {
                name: 'ab-crim-harassment',
                label: 'Harcèlement criminel',
            },
            {
                name: 'ab-crim-person',
                label: 'Criminel (menaces)',
            },
            {
                name: 'ab-crim-prop',
                label: 'Criminel (contre les droits de propriété)',
            },
            {
                name: 'ab-crim-sex',
                label: 'Criminel (sexuel)',
            },
            {
                name: 'ab-crim-stup',
                label: 'Criminel (stupéfiant)',
            },
            {
                name: 'ab-crim-transport',
                label: 'Criminel (moyen de transport)',
            },
            {
                name: 'ab-crim-waiver',
                label: 'Criminel (pardon/waiver)',
            },
            {
                name: 'ab-crim-youth',
                label: 'Criminel (jeune contrevenant)',
            },

            {
                name: 'ab-penal-enterprise',
                label: 'Pénal (entreprise)',
            },
            {
                name: 'ab-penal-environment',
                label: 'Pénal (environnement)',
            },
            {
                name: 'ab-penal-hunting',
                label: 'Pénal (chasse)',
            },
            {
                name: 'ab-penal-other',
                label: 'Infraction pénal (autre)',
            },
            {
                name: 'ab-penal-road',
                label: 'Pénal (infraction de la route)',
            },
            {
                name: 'ab-theft-5000-less',
                label: 'Vol',
            },
        ],
    },
    {
        name: 'ab-family',
        label: 'Famille et protection de la jeunesse',
        certRequired: true,
        children: [
            {
                name: 'ab-family-child-spousal-over-150k',
                label: 'Pension alimentaire (revenu de plus de 150 000$)',
            },
            {
                name: 'ab-family-child-spousal-under-150k',
                label: 'Pension alimentaire (revenu de 150 000$ et moins)',
            },
            {
                name: 'ab-family-contested',
                label: 'Dossiers non-contestés',
            },
            {
                name: 'ab-family-custody',
                label: 'Garde pour enfant',
            },
            {
                name: 'ab-family-family',
                label: 'Divorce/Séparation',
            },
            {
                name: 'ab-family-mediation',
                label: 'Médiation familiale',
            },
            {
                name: 'ab-family-youth',
                label: 'Intervention Enfant',
            },
            {
                name: 'ab-violence',
                label: 'Violence conjugale',
            },
        ],
    },
    {
        name: 'ab-fiscal',
        label: 'Fiscalité et taxes',
        children: [
            {
                name: 'ab-fiscal-enterprise',
                label: 'Entreprise',
            },
            {
                name: 'ab-fiscal-person',
                label: 'Particulier',
            },
        ],
    },
    {
        name: 'ab-immigration',
        label: 'Immigration et citoyenneté',
        certRequired: true,
        immigrationConsultant: true,
        children: [
            {
                name: 'ab-immigration-contest',
                label: 'Contestation (contrôle et appel)',
                immigrationConsultant: true,
            },
            {
                name: 'ab-immigration-other',
                label: 'Autre',
                immigrationConsultant: true,
            },
            {
                name: 'ab-immigration-permanent',
                label: 'Résidence permanente',
                immigrationConsultant: true,
            },
            {
                name: 'ab-immigration-refugee',
                label: 'Réfugié',
                immigrationConsultant: true,
            },
            {
                name: 'ab-immigration-sponsorship',
                label: 'Parrainage',
                immigrationConsultant: true,
            },
            {
                name: 'ab-immigration-work-permit',
                label: "Permis d'étude et de travail",
                immigrationConsultant: true,
            },
        ],
    },
    {
        name: 'ab-municipal',
        label: 'Municipal',
        children: null,
        topLevel: true,
    },
    {
        name: 'ab-realestate',
        label: 'Immobilier',
        children: [
            {
                name: 'ab-condo',
                label: 'Copropriété',
            },
            {
                name: 'ab-construction',
                label: 'Construction',
            },
            {
                name: 'ab-realestate-title',
                label: 'Titre, bornage, servitude, etc',
            },
            {
                name: 'ab-realestate-transaction',
                label: 'Achat/Vente',
            },
            {
                name: 'ab-realestate-vice',
                label: 'Litige',
            },
        ],
    },
    {
        name: 'ab-rental',
        label: 'Logement',
        children: [
            {
                name: 'ab-rental-landlord',
                label: 'Propriétaire',
            },
            {
                name: 'ab-rental-renter',
                label: 'Locataire',
            },
        ],
    },
    {
        name: 'ab-liability',
        label: 'Responsabilité civile',
        children: [
            {
                name: 'ab-liability-general',
                label: 'Générale',
            },
            {
                name: 'ab-liability-injury',
                label: 'Blessure corporelle',
            },
            {
                name: 'ab-liability-medical',
                label: 'Erreur médicale',
            },
            {
                name: 'ab-liability-neighborhood',
                label: 'Trouble de voisinage',
            },
            {
                name: 'ab-liability-pro',
                label: 'Professionnelle et disciplinaire',
            },
            {
                name: 'ab-liability-mva',
                label: 'MVA',
            },
            {
                name: 'ab-liability-slander',
                label: 'Diffamation / atteinte à la réputation',
            },
        ],
    },
    {
        name: 'ab-rights',
        label: 'Droits et libertés',
        children: [
            {
                name: 'ab-rights-care',
                label: 'Détention, traitement et soin en établissement',
            },
            {
                name: 'ab-rights-constitution',
                label: 'Constitution et chartes',
            },

            {
                name: 'ab-rights-native',
                label: 'Autochtone',
            },
            {
                name: 'ab-rights-protection',
                label: 'Personnes vulnérables (curatelle, tutelle)',
            },
            {
                name: 'ab-rights-tribunal',
                label: "Commission des droits de la personne de l'Alberta",
            },
        ],
    },
    {
        name: 'ab-succession',
        label: 'Succession',
        children: [
            {
                name: 'ab-estate-admin',
                label: 'Administration de succession',
            },
            {
                name: 'ab-estate-litigation',
                label: 'Litige successoral',
            },
            {
                name: 'ab-estate-wills',
                label: 'Testaments',
            },
        ],
    },
    {
        name: 'ab-work',
        label: 'Travail',
        children: [
            {
                name: 'ab-work-employee',
                label: 'Harcèlement / pratiques interdites',
            },
            {
                name: 'ab-work-employer',
                label: 'Employeur',
            },
            {
                name: 'ab-work-termination',
                label: 'Congédiement',
            },
            {
                name: 'ab-work-wcb',
                label: 'WCB-Alberta',
            },
        ],
    },
]

export const lawyerTypesBC = [
    {
        name: 'bc-admin',
        label: 'Administratif',
        children: [
            {
                name: 'bc-cvap',
                label: 'CVAP',
            },
            {
                name: 'bc-supreme',
                label: 'Cour Suprême',
            },
            {
                name: 'bc-employment',
                label: 'Employment',
            },
            {
                name: 'bc-pensions',
                label: 'Rentes / pensions',
            },
            {
                name: 'bc-social-help',
                label: 'Aide sociale / chômage',
            },
        ],
    },
    {
        name: 'bc-bankruptcy',
        label: 'Faillite et insolvabilité',
        children: [
            {
                name: 'bc-bankruptcy-enterprise',
                label: 'Entreprise',
            },
            {
                name: 'bc-bankruptcy-person',
                label: 'Particulier',
            },
        ],
    },
    {
        name: 'bc-business',
        label: 'Affaires',
        children: [
            {
                name: 'bc-arbitrage',
                label: 'Arbitrage et médiation commerciale',
            },
            {
                name: 'bc-business-litige',
                label: 'Litige',
            },
            {
                name: 'bc-commercial',
                label: 'Commercial (contractuel)',
            },
            {
                name: 'bc-corp-franchise',
                label: 'Corporatif (franchisage)',
            },
            {
                name: 'bc-corp-ma',
                label: 'Corporatif (fusion/achat/vente/transfert)',
            },
            {
                name: 'bc-corp-minutes',
                label: 'Livres des minutes',
            },
            {
                name: 'bc-corp-npo',
                label: 'Corporatif (OBNL)',
            },
            {
                name: 'bc-corp-reorg',
                label: 'Corporatif (réorganisation)',
            },
            {
                name: 'bc-corp-start',
                label: 'Corporatif (démarrage)',
            },
            {
                name: 'bc-ip',
                label: 'Propriété intellectuelle',
            },
            {
                name: 'bc-litige-action',
                label: 'Litige (recouvrement de créances)',
            },
            {
                name: 'bc-litige-competition',
                label: 'Litige (Clauses de non-concurrence et concurrence déloyale)',
            },

            {
                name: 'bc-litige-post-transac',
                label: 'Litige (post-transaction)',
            },
            {
                name: 'bc-litige-shareholders',
                label: 'Litige (entre actionnaires)',
            },
        ],
    },
    {
        name: 'bc-civil',
        label: 'Civil (général)',
        children: [
            {
                name: 'bc-civil-account',
                label: 'Action sur compte',
            },
            {
                name: 'bc-civil-banking',
                label: 'Bancaire',
            },
            {
                name: 'bc-civil-health-insurance',
                label: 'Assurance (personne)',
            },
            {
                name: 'bc-civil-prop-insurance',
                label: 'Assurance (biens)',
            },
            {
                name: 'bc-civil-small-claims',
                label: 'Cour des petites créances',
            },
            {
                name: 'bc-colAction',
                label: 'Action collective',
            },
            {
                name: 'bc-consumer',
                label: 'Consommation',
            },
            {
                name: 'bc-contracts',
                label: 'Contrats, vente et louage',
            },
        ],
    },
    {
        name: 'bc-criminal',
        label: 'Criminel et infraction réglementaire',
        certRequired: true,
        children: [
            {
                name: 'bc-crim-assault',
                label: 'Voies de fait',
            },
            {
                name: 'bc-crim-firearm',
                label: 'Criminel (arme à feu)',
            },
            {
                name: 'bc-crim-fraud',
                label: 'Criminel (fraude)',
            },
            {
                name: 'bc-crim-harassment',
                label: 'Harcèlement criminel',
            },
            {
                name: 'bc-crim-person',
                label: 'Criminel (menaces)',
            },
            {
                name: 'bc-crim-prop',
                label: 'Criminel (contre les droits de propriété)',
            },
            {
                name: 'bc-crim-sex',
                label: 'Criminel (sexuel)',
            },
            {
                name: 'bc-crim-stup',
                label: 'Criminel (stupéfiant)',
            },
            {
                name: 'bc-crim-transport',
                label: 'Criminel (moyen de transport)',
            },
            {
                name: 'bc-crim-waiver',
                label: 'Criminel (pardon/waiver)',
            },
            {
                name: 'bc-crim-youth',
                label: 'Criminel (jeune contrevenant)',
            },

            {
                name: 'bc-penal-enterprise',
                label: 'Pénal (entreprise)',
            },
            {
                name: 'bc-penal-environment',
                label: 'Pénal (environnement)',
            },
            {
                name: 'bc-penal-hunting',
                label: 'Pénal (chasse)',
            },
            {
                name: 'bc-penal-other',
                label: 'Infraction pénal (autre)',
            },
            {
                name: 'bc-penal-road',
                label: 'Pénal (infraction de la route)',
            },
            {
                name: 'bc-theft-5000-less',
                label: 'Vol',
            },
        ],
    },
    {
        name: 'bc-family',
        label: 'Famille et protection de la jeunesse',
        certRequired: true,
        children: [
            {
                name: 'bc-family-child-spousal-over-150k',
                label: 'Pension alimentaire (revenu de plus de 150 000$)',
            },
            {
                name: 'bc-family-child-spousal-under-150k',
                label: 'Pension alimentaire (revenu de 150 000$ et moins)',
            },
            {
                name: 'bc-family-contested',
                label: 'Dossiers non-contestés',
            },
            {
                name: 'bc-family-custody',
                label: 'Garde pour enfant',
            },
            {
                name: 'bc-family-family',
                label: 'Divorce/Séparation',
            },
            {
                name: 'bc-family-mediation',
                label: 'Médiation familiale',
            },
            {
                name: 'bc-family-youth',
                label: 'Jeunesse',
            },
            {
                name: 'bc-violence',
                label: 'Violence conjugale',
            },
        ],
    },
    {
        name: 'bc-fiscal',
        label: 'Fiscalité et taxes',
        children: [
            {
                name: 'bc-fiscal-enterprise',
                label: 'Entreprise',
            },
            {
                name: 'bc-fiscal-person',
                label: 'Particulier',
            },
        ],
    },
    {
        name: 'bc-immigration',
        label: 'Immigration et citoyenneté',
        certRequired: true,
        immigrationConsultant: true,
        children: [
            {
                name: 'bc-immigration-contest',
                label: 'Contestation (contrôle et appel)',
                immigrationConsultant: true,
            },
            {
                name: 'bc-immigration-other',
                label: 'Autre',
                immigrationConsultant: true,
            },
            {
                name: 'bc-immigration-permanent',
                label: 'Résidence permanente',
                immigrationConsultant: true,
            },
            {
                name: 'bc-immigration-refugee',
                label: 'Réfugié',
                immigrationConsultant: true,
            },
            {
                name: 'bc-immigration-sponsorship',
                label: 'Parrainage',
                immigrationConsultant: true,
            },
            {
                name: 'bc-immigration-work-permit',
                label: "Permis d'étude et de travail",
                immigrationConsultant: true,
            },
        ],
    },
    {
        name: 'bc-municipal',
        label: 'Municipal',
        children: null,
        topLevel: true,
    },
    {
        name: 'bc-realestate',
        label: 'Immobilier',
        children: [
            {
                name: 'bc-condo',
                label: 'Copropriété',
            },
            {
                name: 'bc-construction',
                label: 'Construction',
            },
            {
                name: 'bc-realestate-title',
                label: 'Titre, bornage, servitude, etc',
            },
            {
                name: 'bc-realestate-transaction',
                label: 'Achat/Vente',
            },
            {
                name: 'bc-realestate-vice',
                label: 'Litige',
            },
        ],
    },
    {
        name: 'bc-rental',
        label: 'Logement',
        children: [
            {
                name: 'bc-rental-landlord',
                label: 'Propriétaire',
            },
            {
                name: 'bc-rental-renter',
                label: 'Locataire',
            },
        ],
    },
    {
        name: 'bc-liability',
        label: 'Responsabilité civile',
        children: [
            {
                name: 'bc-liability-general',
                label: 'Générale',
            },
            {
                name: 'bc-liability-injury',
                label: 'Blessure corporelle',
            },
            {
                name: 'bc-liability-medical',
                label: 'Erreur médicale',
            },
            {
                name: 'bc-liability-neighborhood',
                label: 'Trouble de voisinage',
            },
            {
                name: 'bc-liability-pro',
                label: 'Professionnelle et disciplinaire',
            },
            {
                name: 'bc-liability-sabia',
                label: "Demandes d'indemnités d'accident couvertes par Loi sur les Assurances",
            },
            {
                name: 'bc-liability-slander',
                label: 'Diffamation / atteinte à la réputation',
            },
        ],
    },
    {
        name: 'bc-rights',
        label: 'Droits et libertés',
        children: [
            {
                name: 'bc-rights-care',
                label: 'Soin et traitement involontaire',
            },
            {
                name: 'bc-rights-constitution',
                label: 'Constitution et chartes',
            },

            {
                name: 'bc-rights-native',
                label: 'Autochtone',
            },
            {
                name: 'bc-rights-protection',
                label: 'Personnes vulnérables (curatelle, tutelle, conseil au majeur, POA)',
            },
            {
                name: 'bc-rights-tribunal',
                label: 'Tribunal des droits de la personne BC',
            },
        ],
    },
    {
        name: 'bc-succession',
        label: 'Succession',
        children: [
            {
                name: 'bc-estate-admin',
                label: 'Administration de succession',
            },
            {
                name: 'bc-estate-litigation',
                label: 'Litige successoral',
            },
            {
                name: 'bc-estate-wills',
                label: 'Testaments',
            },
        ],
    },
    {
        name: 'bc-work',
        label: 'Travail',
        children: [
            {
                name: 'bc-work-employee',
                label: 'Harcèlement / pratiques interdites',
            },
            {
                name: 'bc-work-employer',
                label: 'Employeur',
            },
            {
                name: 'bc-work-termination',
                label: 'Congédiement',
            },
            {
                name: 'bc-work-wsbc',
                label: 'WorkSafeBC',
            },
        ],
    },
]

export default lawyerTypes

export const checkIfParentOf = (possibleParent, possibleChild) => {
    if (
        flatMap[possibleChild] &&
        flatMap[possibleChild].parent === possibleParent
    ) {
        return true
    }
    return false
}

export const adminLawyerTypes = (function () {
    const adminTypes = []
    lawyerTypes.forEach((type) => {
        if (type.children) {
            adminTypes.push(...type.children)
        } else {
            adminTypes.push(type)
        }
    })
    return adminTypes
})()

export const allLawyerTypes = (function () {
    const adminTypes = []
    lawyerTypes.forEach((type) => {
        adminTypes.push({
            name: type.name,
            label: type.label,
            parent: true,
        })

        if (type.children) {
            adminTypes.push(...type.children)
        }
    })
    return adminTypes
})()

export const userLawyerTypesMappings = (function () {
    const mappings = {}
    lawyerTypes.forEach((type) => {
        mappings[type.label] = type.name
    })
    return mappings
})()

function mapTypes(types, newMap) {
    types.forEach((type) => {
        newMap[type.name] = type.label
        if (type.children) {
            type.children.forEach((childType) => {
                newMap[childType.name] = childType.label
            })
        }
    })
}

export const lawyerTypesMappings = (function () {
    const mappings = {}
    mapTypes(lawyerTypes, mappings)
    mapTypes(lawyerTypesON, mappings)
    mapTypes(lawyerTypesAB, mappings)
    mapTypes(lawyerTypesBC, mappings)
    return mappings
})()

export const lawyerTypesAdminMappings = (function () {
    const mappings = {}
    lawyerTypes.forEach((type) => {
        if (type.children) {
            type.children.forEach((childType) => {
                mappings[childType.name] = childType.label
            })
        } else {
            mappings[type.name] = type.label
        }
    })
    return mappings
})()

const flatMap = (function () {
    const mappings = {}
    lawyerTypes.forEach((type) => {
        if (type.children) {
            type.children.forEach((childType) => {
                mappings[childType.name] = {
                    ...childType,
                    parent: type.name,
                    jh: type.jh,
                }
            })
            mappings[type.name] = type
        } else {
            mappings[type.name] = type
        }
    })
    lawyerTypesON.forEach((type) => {
        if (type.children) {
            type.children.forEach((childType) => {
                mappings[childType.name] = {
                    ...childType,
                    parent: type.name,
                    jh: type.jh,
                }
            })
            mappings[type.name] = type
        } else {
            mappings[type.name] = type
        }
    })
    lawyerTypesAB.forEach((type) => {
        if (type.children) {
            type.children.forEach((childType) => {
                mappings[childType.name] = {
                    ...childType,
                    parent: type.name,
                    jh: type.jh,
                }
            })
            mappings[type.name] = type
        } else {
            mappings[type.name] = type
        }
    })
    lawyerTypesBC.forEach((type) => {
        if (type.children) {
            type.children.forEach((childType) => {
                mappings[childType.name] = {
                    ...childType,
                    parent: type.name,
                    jh: type.jh,
                }
            })
            mappings[type.name] = type
        } else {
            mappings[type.name] = type
        }
    })
    return mappings
})()

export const checkBlockType = (revenueCode, juridicalHelp, lawyerType) => {
    const lawyerTypeDetails = lawyerTypesFlatMap[lawyerType]
    if (!lawyerTypeDetails) {
        return MP
    }
    if (juridicalHelp) {
        if (lawyerTypeDetails?.jh && juridicalHelp) {
            return LEGAL_AID
        }
    }
    if (lawyerTypeDetails.defaultBlockType) {
        return lawyerTypeDetails.defaultBlockType
    }
    if (
        lawyerTypeDetails.parent &&
        lawyerTypesFlatMap[lawyerTypeDetails.parent].defaultBlockType
    ) {
        return lawyerTypesFlatMap[lawyerTypeDetails.parent].defaultBlockType
    }

    return MP
}

export const lawyerTypesFlatMap = flatMap
